import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { isAxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';

export const fetchUser = async (userId) => {
  const { data } = await authApiClient.get(`/users/${userId}`);
  return data;
};

export const useGetUserHandler = ({ userId, enabled = true } = {}) => {
  const dispatch = useDispatch();
  const query = useQuery({
    queryKey: ['auth-user', userId],
    queryFn: () => fetchUser(userId),
    enabled: Boolean(userId) && enabled,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!query.isError) return;

    if (isAxiosError(query.error)) {
      dispatch(
        showSnackbar({
          message: query.error.response?.data?.errors?.message || query.error.message,
          severity: 'error',
        }),
      );
      return;
    }

    dispatch(
      showSnackbar({
        message: 'Failed to fetch user',
        severity: 'error',
      }),
    );
  }, [dispatch, query.error, query.isError]);

  return {
    user: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
